<template>
  <div
    v-if="data"
    class="favorite-note"
  >
    <textarea
      v-model="data.note"
      rows="3"
      maxlength="200"
      :placeholder="$t('favorites.note.empty', { n: 200 })"
      @keyup="updateNote"
    />
    <span
      class="saved"
      :class="{ active: saved }"
    >{{ $t('favorites.note.saved') }}</span>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'FavoritesNote',
  props: {
    favorite: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    data: null,
    saved: false,
    updateTimeout: null,
    savedTimeout: null
  }),
  mounted () {
    // Use cloned data to prevent data got overwrite when typing in Zhuyin or something non-instant input IME
    this.data = _.cloneDeep(this.favorite)
  },
  beforeDestroy () {
    clearTimeout(this.updateTimeout)
    clearTimeout(this.savedTimeout)
  },
  methods: {
    updateNote (e) {
      clearTimeout(this.updateTimeout)
      this.updateTimeout = setTimeout(() => {
        this.$emit('update', this.data)
        this.showSaved()
      }, 500)
    },
    showSaved () {
      clearTimeout(this.savedTimeout)
      this.saved = true
      this.savedTimeout = setTimeout(() => {
        this.saved = false
      }, 1000)
    }
  }
}
</script>

<style lang="stylus" scoped>
.favorite-note {
  position: relative

  textarea {
    width: 100%
    background: #f1f1f1
    padding: 8px
    display: block
    font-size: 15px
    line-height: 20px
    resize: none
  }
  .saved {
    position: absolute
    right: 5px
    bottom: 5px
    font-size: 13px
    line-height: 1
    color: $vrl-primary-text
    text-shadow: none
    transition: opacity .1s linear
    pointer-events: none
    opacity: 0

    &.active {
      opacity: 1
    }
  }
}
</style>
